<template>
    <svg width="28" height="28" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 68 68" style="enable-background:new 0 0 68 68;" xml:space="preserve">

<g>
	<rect class="st0" opacity="0" width="28" height="28"/>
    <path class="svg-warning-color" d="M34,10.3L6.7,56.6h54.7L34,10.3z M34,14.6l23.5,39.8H10.5L34,14.6z M36,21.6h-4v22.9h4V21.6z M34,46.9
		c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9C36.9,48.1,35.6,46.9,34,46.9z"/>
</g>
</svg>

</template>

<script>
    export default {
        name: "warningIcon"
    }
</script>





// WEBPACK FOOTER //
// src/common/components/svg/shared/warningIcon.vue